<template>
    <div class="container">
        <h3>{{ $store.getters['EventStore/eventInfo'].name }}</h3>
        <h1>Enviar Email para os capitães (quem comprou)</h1>
        
        <div class="row">
            <div class="col-6">
                <b-button @click="toggleForm" variant="primary">
                    {{ showForm ? 'Ocultar Formulário' : 'Enviar Email' }}
                </b-button>
            </div>
            
            <div class="col-2 tr"></div>

            <div class="col-4">
                <router-link class='btn btn-primary' to="registrations">Ver equipes</router-link>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <b-form v-if="showForm" @submit.prevent="submitEmail">
                    <b-form-group label="Assunto do Email" label-for="subject">
                        <b-form-input 
                            id="subject" 
                            v-model="emailData.subject" 
                            required
                            placeholder="Digite o assunto do email"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group label="Corpo do Email" label-for="body">
                        <div id="quill-editor" style="height: 300px;background-color: white;"></div>
                    </b-form-group>

                    <b-form-group label="Filtros (Opcional)">
                        <div class="row">
                            <!-- <div class="col-6"> -->
                                <!-- <b-form-group label="Competições" label-for="competitionIds">
                                    <b-form-select 
                                        id="competitionIds" 
                                        v-model="emailData.competitionIds"
                                        :options="competitionOptions"
                                        multiple
                                        :select-size="4"
                                    >
                                        <template v-slot:first>
                                            <b-form-select-option :value="null" disabled>
                                                -- Selecione as competições --
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                    <small class="form-text text-muted">
                                        Segure Ctrl/Cmd para selecionar múltiplas competições. Deixe vazio para todas.
                                    </small>
                                </b-form-group> -->
                            <!-- </div> -->
                            <div class="col-12">
                                <b-form-group label="Categorias *" label-for="categoryIds">
                                    <b-form-select 
                                        id="categoryIds" 
                                        v-model="emailData.categoryIds"
                                        :options="categoryOptions"
                                        multiple
                                        :select-size="4"
                                        required
                                        :state="emailData.categoryIds.length > 0 ? true : null"
                                    >
                                        <template v-slot:first>
                                            <b-form-select-option :value="null" disabled>
                                                -- Selecione as categorias (obrigatório) --
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                    <b-form-invalid-feedback>
                                        É obrigatório selecionar pelo menos uma categoria.
                                    </b-form-invalid-feedback>
                                    <small class="form-text text-muted">
                                        Segure Ctrl/Cmd para selecionar múltiplas categorias. <strong>Obrigatório.</strong>
                                    </small>
                                </b-form-group>
                            </div>
                        </div>
                    </b-form-group>

                    <div v-if="recipientCount !== null" class="form-text text-muted mb-2">
                        Esse envio atingirá <strong>{{ recipientCount }}</strong> capitão(ões).
                    </div>

                    <div class="form-group">
                        <b-button
                            type="submit"
                            variant="primary"
                            :disabled="sending"
                            class="mr-2"
                        >
                            <span v-if="sending">
                                <b-spinner small></b-spinner>
                                Enviando...
                            </span>
                            <span v-else>Enviar para todos</span>
                        </b-button>
                        <b-button
                            variant="outline-secondary"
                            @click="sendTest"
                            :disabled="sending"
                            class="mr-2"
                        >
                            Enviar teste
                        </b-button>
                        <b-button
                            variant="secondary"
                            @click="resetForm"
                            :disabled="sending"
                        >
                            Limpar
                        </b-button>
                    </div>
                </b-form>

                <div v-if="errorMessage" class="alert alert-danger mt-3">
                    {{ errorMessage }}
                </div>

                <div v-if="successMessage" class="alert alert-success mt-3">
                    {{ successMessage }}
                </div>

                <!-- Histórico de Envios -->
                <div v-if="emailHistory.length > 0" class="mt-4">
                    <h4>Histórico de Envios (desse computador, não é global)</h4>
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Data/Hora</th>
                                <th>Assunto</th>
                                <th>Total de Clientes</th>
                                <th>Enviados</th>
                                <th>Falhas</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(history, index) in emailHistory" :key="index">
                                <td>{{ formatDate(history.timestamp) }}</td>
                                <td>{{ history.subject }}</td>
                                <td>{{ history.totalClients }}</td>
                                <td class="text-success">{{ history.emailsSent }}</td>
                                <td class="text-danger">{{ history.emailsFailed }}</td>
                                <td>
                                    <span 
                                        :class="history.emailsFailed === 0 ? 'badge badge-success' : 'badge badge-warning'"
                                    >
                                        {{ history.emailsFailed === 0 ? 'Sucesso' : 'Parcial' }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';

export default {
    data() {
        return {
            emailData: {
                subject: '',
                body: '',
                isHtml: true,
                competitionIds: [],
                categoryIds: []
            },

            showForm: false,
            sending: false,
            errorMessage: '',
            successMessage: '',
            emailHistory: [],
            editorInitialized: false,
            quillInstance: null,
            recipientCount: null,
            countLoading: false
        }
    },

    watch: {
        'emailData.categoryIds': function() {
            this.fetchRecipientCount();
        }
    },

    created: function() {
        this.$store.dispatch('EventStore/loadEvent', this.$route.params.eventid);
        this.loadEmailHistory();
    },

    mounted() {
        this.initQuill();
    },

    beforeDestroy() {
        if (this.quillInstance) {
            this.quillInstance = null;
        }
    },

    computed: {
        eventInfo: function() {
            return this.$store.getters['EventStore/eventInfo'];
        },
        
        competitionOptions: function() {
            const competitions = this.eventInfo.competitions || [];
            return competitions.map(comp => ({
                value: comp.id,
                text: comp.name
            }));
        },
        
        categoryOptions: function() {
            const competitions = this.eventInfo.competitions || [];
            let categories = [];
            
            // Extrair todas as categorias de todas as competições
            competitions.forEach(comp => {
                if (comp.categories) {
                    comp.categories.forEach(cat => {
                        categories.push({
                            value: cat.id,
                            text: `${comp.name} - ${cat.name}`
                        });
                        
                        // Adicionar subcategorias se existirem
                        if (cat.subcategories) {
                            cat.subcategories.forEach(subcat => {
                                categories.push({
                                    value: subcat.id,
                                    text: `${comp.name} - ${cat.name} - ${subcat.name}`
                                });
                            });
                        }
                    });
                }
            });
            
            return categories;
        }
    },

    methods: {
        loadQuillResources() {
            return new Promise((resolve, reject) => {
                // Verificar se o Quill já está carregado
                if (window.Quill) {
                    resolve();
                    return;
                }

                // Carregar CSS do Quill
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = 'https://cdn.quilljs.com/1.3.6/quill.snow.css';
                document.head.appendChild(link);

                // Carregar JS do Quill
                const script = document.createElement('script');
                script.src = 'https://cdn.quilljs.com/1.3.6/quill.min.js';
                script.onload = resolve;
                script.onerror = reject;
                document.head.appendChild(script);
            });
        },

        async initQuill() {
            try {
                // Carregar os recursos do Quill primeiro
                await this.loadQuillResources();
                
                // Aguardar um pouco para garantir que o Quill está totalmente carregado
                await new Promise(resolve => setTimeout(resolve, 100));
                
                // Verificar se o container existe
                const container = document.getElementById('quill-editor');
                if (!container) {
                    console.error('Container do Quill não encontrado');
                    return;
                }

                // Remover editor existente se houver
                if (this.quillInstance) {
                    this.quillInstance = null;
                    container.innerHTML = '';
                }

                // Inicializar o editor Quill
                this.quillInstance = new window.Quill('#quill-editor', {
                    theme: 'snow',
                    placeholder: 'Digite o conteúdo HTML do email...',
                    modules: {
                        toolbar: [
                            ['bold', 'italic', 'underline', 'strike'],
                            ['blockquote', 'code-block'],
                            [{ 'header': 1 }, { 'header': 2 }],
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                            [{ 'script': 'sub'}, { 'script': 'super' }],
                            [{ 'indent': '-1'}, { 'indent': '+1' }],
                            [{ 'direction': 'rtl' }],
                            [{ 'size': ['small', false, 'large', 'huge'] }],
                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'font': [] }],
                            [{ 'align': [] }],
                            ['clean'],
                            ['link']
                        ]
                    }
                });

                // Sincronizar conteúdo com o modelo de dados
                this.quillInstance.on('text-change', () => {
                    this.emailData.body = this.quillInstance.root.innerHTML;
                });
                
                this.editorInitialized = true;
            } catch (error) {
                console.error('Erro ao carregar Quill:', error);
            }
        },

        toggleForm() {
            this.showForm = !this.showForm;
            if (!this.showForm) {
                this.resetMessages();
            } else {
                // Reinicializar o editor quando o formulário for mostrado
                this.$nextTick(async () => {
                    await this.initQuill();
                });
            }
        },

        resetForm() {
            this.emailData = {
                subject: '',
                body: '',
                isHtml: true,
                competitionIds: [],
                categoryIds: []
            };
            
            // Limpar o conteúdo do editor
            if (this.quillInstance) {
                this.quillInstance.setContents([]);
            }
            
            this.resetMessages();
        },

        resetMessages() {
            this.errorMessage = '';
            this.successMessage = '';
        },

        submitEmail() {
            this.resetMessages();

            // Validar se pelo menos uma categoria foi selecionada
            if (!this.emailData.categoryIds || this.emailData.categoryIds.length === 0) {
                this.errorMessage = 'É obrigatório selecionar pelo menos uma categoria.';
                return;
            }

            const count = this.recipientCount;
            const msg = count !== null
                ? `Você está prestes a enviar para ${count} capitão(ões). Confirma?`
                : 'Você está prestes a enviar o email para todos os capitães filtrados. Confirma?';
            if (!window.confirm(msg)) {
                return;
            }

            this.sending = true;

            const payload = {
                subject: this.emailData.subject,
                body: this.emailData.body,
                isHtml: this.emailData.isHtml,
                competitionIds: this.emailData.competitionIds.length > 0 ? this.emailData.competitionIds : undefined,
                categoryIds: this.emailData.categoryIds
            };

            api.postJSON(`events/${this.$route.params.eventid}/send-filtered-email`, payload)
                .then(response => {
                    this.successMessage = `Email enviado com sucesso! ${response.data.emailsSent} emails enviados para ${response.data.totalClients} clientes únicos.`;
                    
                    // Adicionar ao histórico
                    this.emailHistory.unshift({
                        timestamp: new Date(),
                        subject: this.emailData.subject,
                        totalClients: response.data.totalClients,
                        emailsSent: response.data.emailsSent,
                        emailsFailed: response.data.emailsFailed
                    });
                    
                    this.saveEmailHistory();
                    this.resetForm();
                    this.showForm = false;
                })
                .catch(error => {
                    let errorMsg = error.message;
                    if (error.response && error.response.data && error.response.data.error && error.response.data.error.message) {
                        errorMsg = error.response.data.error.message;
                    }
                    this.errorMessage = 'Erro ao enviar email: ' + errorMsg;
                })
                .finally(() => {
                    this.sending = false;
                });
        },

        sendTest() {
            this.resetMessages();
            if (!this.emailData.subject || !this.emailData.body) {
                this.errorMessage = 'Preencha assunto e corpo antes de enviar o teste.';
                return;
            }
            const testEmail = window.prompt('Digite o email para receber o teste:');
            if (!testEmail) return;
            const trimmed = testEmail.trim();
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
                this.errorMessage = 'Email de teste inválido.';
                return;
            }

            this.sending = true;
            const payload = {
                subject: this.emailData.subject,
                body: this.emailData.body,
                isHtml: this.emailData.isHtml,
                testEmail: trimmed
            };
            api.postJSON(`events/${this.$route.params.eventid}/send-filtered-email`, payload)
                .then(() => {
                    this.successMessage = `Teste enviado para ${trimmed}.`;
                })
                .catch(error => {
                    let errorMsg = error.message;
                    if (error.response && error.response.data && error.response.data.error && error.response.data.error.message) {
                        errorMsg = error.response.data.error.message;
                    }
                    this.errorMessage = 'Erro ao enviar teste: ' + errorMsg;
                })
                .finally(() => {
                    this.sending = false;
                });
        },

        fetchRecipientCount() {
            if (!this.emailData.categoryIds || this.emailData.categoryIds.length === 0) {
                this.recipientCount = null;
                return;
            }
            this.countLoading = true;
            const payload = {
                subject: 'count',
                body: 'count',
                countOnly: true,
                competitionIds: this.emailData.competitionIds.length > 0 ? this.emailData.competitionIds : undefined,
                categoryIds: this.emailData.categoryIds
            };
            api.postJSON(`events/${this.$route.params.eventid}/send-filtered-email`, payload)
                .then(response => {
                    this.recipientCount = response.data && typeof response.data.count === 'number' ? response.data.count : null;
                })
                .catch(() => {
                    this.recipientCount = null;
                })
                .finally(() => {
                    this.countLoading = false;
                });
        },

        loadEmailHistory() {
            const eventId = this.$route.params.eventid;
            const savedHistory = localStorage.getItem(`emailHistory_${eventId}`);
            if (savedHistory) {
                this.emailHistory = JSON.parse(savedHistory);
            }
        },

        saveEmailHistory() {
            const eventId = this.$route.params.eventid;
            // Manter apenas os últimos 10 registros
            const historyToSave = this.emailHistory.slice(0, 10);
            localStorage.setItem(`emailHistory_${eventId}`, JSON.stringify(historyToSave));
        },

        formatDate(date) {
            return new Date(date).toLocaleString('pt-BR');
        }
    }
}
</script>

<style lang="stylus">
.container
    .alert
        margin-top: 1rem
    
    .badge
        &.badge-success
            background-color: #28a745
        &.badge-warning
            background-color: #ffc107
            color: #212529
    
    .form-text
        font-size: 0.875rem
        color: #6c757d

#quill-editor
    .ql-editor
        min-height: 250px
        
    .ql-toolbar
        border-top: 1px solid #ccc
        border-left: 1px solid #ccc
        border-right: 1px solid #ccc
        
    .ql-container
        border-bottom: 1px solid #ccc
        border-left: 1px solid #ccc
        border-right: 1px solid #ccc
</style> 